/** Absolute http(s) URL only; ignores literal "null"/"undefined" from bad client templates. */
export function resolveHttpReturnUrl(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s || /^null$/i.test(s) || /^undefined$/i.test(s)) return null;
  try {
    const u = new URL(s);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    return u;
  } catch {
    return null;
  }
}

/** `deeplink` first when valid; otherwise `redirect_uri` (e.g. WebView-only clients). */
export function pickProfileReturnUrl(deeplink, redirectUri) {
  return resolveHttpReturnUrl(deeplink) || resolveHttpReturnUrl(redirectUri);
}

/**
 * If `deeplink` or `redirect_uri` is a valid return URL, sends the user there
 * (e.g. mobile app WebView). Returns `true` if so; if `false`, use in-app back.
 */
export function tryRedirectToDeeplinkOrRedirectUri(deeplink, redirectUri) {
  const next = pickProfileReturnUrl(deeplink, redirectUri);
  if (!next) return false;
  window.location.href = next.toString();
  return true;
}
